import React from 'react';

const CustomTextMessage = (props) => {
  //console.log(props);
  const _prev = () => {
    const preText = props.state.prevMessage;
    //console.log(preText);
    props.actions._categoryPrev(preText);
  };
  return (
    <>
      <div className="ir-chat-contaner">
        <div className="custom-chat-div">
          <div className="custom-chat-div-left">
            <img src="/img/icon_chatbot.png" />
          </div>
          <div className="custom-chat-div-right">
            <div className={'ri-chat-message-bot'}>{props.payload.message}</div>
            {/* <div className={'ri-chat-message-bot'}>
              <img
                src="https://i.pinimg.com/originals/cf/da/fa/cfdafa4dc6aab40eae1c5315c02b9339.jpg"
                style={{ width: '100%' }}
              />
            </div> */}
            <div className="ri-chat-time">{props.payload.writetime}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomTextMessage;
